var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('van-nav-bar',{attrs:{"title":"我的医院","left-arrow":"","left-text":"返回"},on:{"click-left":_vm.goBackMineView}}),(_vm.currentContact && _vm.currentContact.length !== 0)?_c('div',[_c('myHospitalCard',{attrs:{"detail":_vm.currentContact},on:{"followView":_vm.followView}})],1):_c('noData')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }